"use strict";

exports.__esModule = true;
exports.metricsDefinition = void 0;
var metricsDefinition = exports.metricsDefinition = function metricsDefinition() {
  return {
    columns: [],
    parseData: function parseData(responseData) {
      return responseData;
    },
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: true,
        defaultPageSize: "auto",
        columns: []
      };
    }
  };
};